import { createEffect, sample } from 'effector';
import $$api from 'models/api';
import { $global } from 'models/store-global';

import env from 'constants/env';

import AlertsService from 'services/AlertsService';

import { MyStore } from 'types/Store';

sample({
    clock: [
        $$api.employer.getEmployerByDomainFx.failData,
        $$api.employer.sendCodeFx.failData,
        $$api.employer.linkEmployeeFx.failData,
        $$api.employer.linkDiscounterFx.failData,
        $$api.employer.checkCodeValidityFx.failData,
    ],
    target: createEffect(AlertsService.handleError),
});

// Handle EmployersApi.getEmployerByDomain.failData
sample({
    source: $global,
    clock: $$api.employer.getEmployerByDomainFx.doneData,
    fn: (store, data): MyStore => ({
        ...store,
        employers: {
            ...(store.employers || {}),
            [data.domain]: data,
        },
    }),
    target: $global,
});

// Handle EmployersApi.sendCode.doneData
sample({
    clock: $$api.employer.sendCodeFx.done,
    fn: ({ params: email }) => email,
    target: createEffect((email: string) => {
        AlertsService.showSuccess('Check your email for the code and continue signing up.');
        AlertsService.showSuccess('Redirecting to sign up page...');
        setTimeout(() => {
            window.location.href = `${env.REACT_APP_APPLICATION_URL}/signup?employer=${email.split('@')[1]}`;
        }, 3000);
    }),
});

// Handle EmployersApi.linkEmployee.doneData
sample({
    clock: $$api.employer.linkEmployeeFx.doneData,
    fn: () => 'User linked successfully',
    target: createEffect(AlertsService.showSuccess),
});

// Handle EmployersApi.linkDiscounter.doneData
sample({
    clock: $$api.employer.linkDiscounterFx.doneData,
    fn: () => 'User linked successfully',
    target: createEffect(AlertsService.showSuccess),
});
